import AlignBg from "../AlignBg";
import WelcomeAbout from "./Sections/WelcomeAbout";
import Companies from "./Sections/Companies";
import Skills from "./Sections/Skills";
import Credentials from "./Sections/Credentials";
import Motivation from "./Sections/Motivation";
import Empower from "./Sections/Empower";
import ProjectSection from "./Sections/ProjectSection";
import CertGallery from "./Sections/CertGallery";

function About() {
  return (
    <div className="About">
      <AlignBg name="About" title="About Daniel Oshinubi" />
      <WelcomeAbout />
      <Companies />
      <Credentials />
      <Skills />
      <Motivation />
      <Empower />
      <ProjectSection />
      <CertGallery />
    </div>
  );
}

export default About;
